"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_STATUS = exports.ORDER_TYPES = void 0;
var ORDER_TYPES;
(function (ORDER_TYPES) {
    ORDER_TYPES[ORDER_TYPES["SALE"] = 1] = "SALE";
    ORDER_TYPES[ORDER_TYPES["ENROLLMENT"] = 5] = "ENROLLMENT";
})(ORDER_TYPES = exports.ORDER_TYPES || (exports.ORDER_TYPES = {}));
;
var ORDER_STATUS;
(function (ORDER_STATUS) {
    ORDER_STATUS[ORDER_STATUS["CART"] = 1] = "CART";
    ORDER_STATUS[ORDER_STATUS["CHECKOUT"] = 2] = "CHECKOUT";
    ORDER_STATUS[ORDER_STATUS["PENDING_PAYMENT"] = 3] = "PENDING_PAYMENT";
    ORDER_STATUS[ORDER_STATUS["COMPLETED_PAYMENT"] = 4] = "COMPLETED_PAYMENT";
    ORDER_STATUS[ORDER_STATUS["FAILED_PAYMENT"] = 5] = "FAILED_PAYMENT";
    ORDER_STATUS[ORDER_STATUS["REDUNDED"] = 6] = "REDUNDED";
    ORDER_STATUS[ORDER_STATUS["CANCELED"] = 7] = "CANCELED";
    ORDER_STATUS[ORDER_STATUS["PENDING_PAYMENT_3DS"] = 9] = "PENDING_PAYMENT_3DS";
})(ORDER_STATUS = exports.ORDER_STATUS || (exports.ORDER_STATUS = {}));
;
